import type { JSX } from 'react'

import { CopyPlusIcon, DropdownMenu, PencilIcon } from '@buffer-mono/popcorn'

import { DeleteContentItemMenuItem } from '~publish/components/ContentItemCard/DeleteContentItemMenuItem'
import type { ContentItemDraft } from '~publish/components/ContentItemCard'
import { useContentItemDraftActions } from '~publish/components/ContentItemCard'
import { MoreActionsDropdown } from '~publish/components/PostCard/PostCardActions/MoreActionsDropdown'

type BoardContentItemCardActionsProps = {
  contentItem: ContentItemDraft
}

/**
 * Curated to match `BoardPostCardActions`: Edit, Duplicate, Delete. Skips
 * "Copy draft link" from the full drafts-feed menu — not worth the row in a
 * glance card.
 */
export function BoardContentItemCardActions({
  contentItem,
}: BoardContentItemCardActionsProps): JSX.Element | null {
  const { edit, duplicate } = useContentItemDraftActions(contentItem)

  return (
    <MoreActionsDropdown>
      <MoreActionsDropdown.Group>
        {contentItem.allowedActions.includes('updateContentItem') && (
          <DropdownMenu.Item onSelect={edit}>
            <PencilIcon />
            Edit
          </DropdownMenu.Item>
        )}
        {/* Duplicate writes nothing: it seeds a fresh composer, and Save
            creates a new draft under its own authorization. */}
        <DropdownMenu.Item onSelect={duplicate}>
          <CopyPlusIcon />
          Duplicate
        </DropdownMenu.Item>
      </MoreActionsDropdown.Group>
      <MoreActionsDropdown.Group>
        <DeleteContentItemMenuItem
          contentItemId={contentItem.id}
          allowedActions={contentItem.allowedActions}
        />
      </MoreActionsDropdown.Group>
    </MoreActionsDropdown>
  )
}
